<template>
    <div id="recruiter_new_evaluations" class="flex_content" v-if="currentEval.saven_test">

        <div id="context_bar">
            <TopbarGoEvalsList />
<!--        <TopBarSteps /> -->
        </div>


        <titlePage v-if="!isLoading">
            <template slot="titleBody">
                <h1 class="page-title title is-size-1">{{ currentEval.candidate_username }}</h1>
                <h2 class="associated_ref_name"><span>{{ getRefName(currentEval.saven_test.sight_ref) }}</span></h2>
                <h3 class="associated_rec_name" v-if="notOwnedEval"><span>{{ currentEval.recruiter_name }}</span></h3>


                <div class="edit_action_buttons">
                    <div class="add_to_position edit_action_button" v-if="canEditEval">
                        <AddToPositionModal :evaluation="currentEval" :positionsList="positionsList" />
                    </div>

                    <div class="add_docs edit_action_button" v-if="currentEval.profile_link">
                        <a class="button is-outlined is-info table-button" target="_blank" :href="currentEval.profile_link" >
                            {{ $t("modules.evaluations.edit.profileLink") }}
                        </a>
                    </div>

                    <div v-if="currentEval.completed">
                        <div class="reports_dropdown edit_action_button" v-if="!currentEval.in_regen">
                            <ReportsDropDown
                                :doc_files="currentEval.docs_ids"
                                :expert_report_url="currentEval.saven_test.expert_report_url"
                                :passeport_report_url="currentEval.saven_test.passeport_report_url"
                                :customer_report_url="currentEval.saven_test.customer_report_url"
                                @deleteFileClicked="deleteFileFromEval"/>
                        </div>
                        <div class="edit_action_button" v-else>
                            <ReportsInGen/>
                        </div>
                    </div>
                </div>
                <div class="edit_action_buttons" v-if="currentEval.completed">
                    <div class="add_to_position edit_action_button" v-if="canEditEval">
                        <ReportRegenModal :evaluation="currentEval" />
                    </div>
                </div>

            </template>
        </titlePage>


        <div v-if="currentEval.completed" >
            <div class="eval_tabs">
                <BtnTab btn-id="ActualTab" :active-tab="currentTab == 'ActualTab'" @btnTab:Clicked="changeTab">
                    {{ $t('modules.evaluations.edit.actualTab') }}
                </BtnTab>
                <BtnTab btn-id="UltimTab" :active-tab="currentTab == 'UltimTab'" @btnTab:Clicked="changeTab">
                    {{ $t('modules.evaluations.edit.ultimTab') }}
                </BtnTab>

                
            </div>

            <div class="tabs_content" >
                <div class="tabs_loader" v-if="!currentTab"><iconLoader  /></div>

                <transition name="survey-fade">
                    <component :is="currentTab" ></component>
                </transition>

            </div>
        </div>

        <div class="container uncompleted_container mini-container" v-else>
            <iconWarning />
            <h3 class="uncompleted_notice title is-size-3">
                {{ $t('modules.evaluations.edit.pendingEvalNotice') }}
            </h3>
            <div class="eval_link">
                <span>{{ $t('modules.evaluations.edit.app_link') }}</span>
                <input type="text" :value="currentEval.eval_link" readonly/>
            </div>
        </div>

    </div>

</template>

<script>

import TitlePage from "@/components/layouts/titlePage"
import TopbarGoEvalsList from "../components/topbar/topbarGoEvalsList"

import ActualTab from "../components/edit/actualTab"
import UltimTab from "../components/edit/ultimTab"


import AddToPositionModal from '../components/index/addToPositionModal'
import ReportsDropDown from '../components/index/reportsDropDown'
import ReportsInGen from '../components/index/ReportsInGen'
import ReportRegenModal from '../components/edit/reportRegenModal'

import AddDocsModal from '../components/index/addDocsModal'
import userCanAccess from '@/modules/auth/stores/helpers/checkAccess.js'


export default {
    name: 'EvaluationsEdit',
    components: {
        TopbarGoEvalsList,
        TitlePage,
        ActualTab,
        UltimTab,
        AddToPositionModal,
        ReportsDropDown,
        ReportsInGen,
        ReportRegenModal,
        AddDocsModal
    },
    beforeCreate() {
        this.$store.dispatch('EvalStore/initEdit', this.$route.params.id).then( () => {this.isLoading = false})
        this.$store.dispatch('PositionStore/indexPositions', {})
    },
    mounted(){
        setTimeout(() => { this.currentTab = 'ActualTab' }, 1000 )
        this.checkReportsRegen()
    },
    data(){
        return {
            isLoading: true,
            currentTab: false,
            intervalId: "",
            userData: JSON.parse(localStorage.getItem('account')).user
        }
    },
    computed: {
        currentEval(){
            return this.$store.state.EvalStore.currentEval
        },
        positionsList(){
            return this.$store.state.PositionStore.positionsList
        },
        notOwnedEval(){
            return this.userData.id != this.currentEval.user_id
        },
        shareModeActive(){
            return JSON.parse(localStorage.getItem('account')).contract.sharing_data_mode == "across_company"
        },
        canEditEval(){
            return !this.notOwnedEval || this.shareModeActive
        },
        isRespect(){
            return JSON.parse(localStorage.getItem('account')).is_respect
        }
    },
    methods: {
        saveUploadedFiles(fileList){
            const evalFiles = JSON.parse(JSON.stringify(this.currentEval.docs_ids))
            const files = this._.union(evalFiles, fileList)
            this.$store.dispatch('EvalStore/saveEval', {id: this.currentEval.id, docs_ids: files})
        },
        getRefName(refItem){
            return refItem.job_titles[this.$i18n.locale]
        },
        isActive(tabName){

        },
        changeTab(tabName){
            this.currentTab = tabName
        },
        checkReportsRegen(){
            this.intervalId = setInterval(() => {
                if (this.currentEval){
                    if (this.currentEval.in_regen){
                        if (this.$route.params.id){
                            this.$store.dispatch('EvalStore/initEdit', this.$route.params.id)
                        }
                    }
                }
            }, 5000)
        },
        deleteFileFromEval(file){
            const evalFiles = JSON.parse(JSON.stringify(this.currentEval.docs_ids))
            this._.remove(evalFiles, function(evalFile){
                return evalFile.file_id == file.file_id
            });
            this.$store.dispatch('EvalStore/saveEval', {id: this.currentEval.id, docs_ids: evalFiles})
        }
    },
    beforeDestroy () {
       clearInterval(this.intervalId)
    }
}
</script>

<style lang="scss" scoped>
#index_eval_content{
    background: $white;
}
.form_material_container{
    max-width: 500px;
    margin: 0 auto;
    .select{
        width: 100%;
        select{
            width: 100%;
        }
    }
}
.tabs_loader{
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 20px;
    svg{
        width: 50px;
        fill: $info;
    }
}

.eval_tabs{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: stretch;
    background-color: $white;
        // padding-left: 70px;
}
.uncompleted_container{
    text-align: center;
    margin: 50px auto;
    svg{
        width: 80px;
        fill: $pending-color;
    }
    .uncompleted_notice{
        max-width: 500px;
        margin: auto;
        color: $pending-color;
    }
}
.edit_action_buttons{
    display: flex;
    justify-content: center;
    .edit_action_button{
        margin: 8px 4px;
    }
}
.associated_rec_name{
    text-align: center;
    font-style: italic;
    font-weight: 600;
    color: $primary;
    font-size: 1.2rem;
}
.eval_link{
    width: 100%;
    margin-top: 30px;
    span{
        font-size: 1.25rem;
    }
    input{
        text-align: center;
        width: 100%;
        border: 1px solid #80808045;
        padding: 12px;
        border-radius: 10px;
    }
}
</style>